/* eslint-disable */


import React, { useEffect, useRef, useState } from "react";
import { Link as RouterLink, useSearchParams, useParams, useNavigate } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';
import {
  Box, MenuItem, Typography,
  Table,
  Card,
  InputAdornment,
  IconButton,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputLabel,
  FormControl,
  OutlinedInput,
  Stack,
  Select,
  Divider,
  LinearProgress
} from '@mui/material';



import { isoDateFormatInDmyhs } from '../utils/formatTime';
import { crossMarkString, showFieldValueWithCheck, getTransactionAnnouncedOrNot } from '../utils/Utilities';
import { APP_CONSTANTS } from '../URLConstants'

// components
import Page from '../components/Page';

import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { useAuth } from "../components/customContextProviders/AuthContext";
import { GetTransactionHistory } from '../network/Organization'


// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));


let currentPage = 1;
let isHasTransactionDataHasNextPage = true;




export default function SoundBoxTransactions({ soundboxDeviceListData, organizationId }) {

  const navigate = useNavigate();
  const { sessionUserData, organizationAudioCubeTerritories } = useAuth()

  const cardRef = useRef(null);


  const [transactionDataLoading, setTransactionDataLoading] = useState(false);
  const [selectedDeviceTab, setSelectedDeviceTab] = useState('1');
  const [deviceTransactionsList, setDeviceTransactionsList] = useState([])
  const [searchTimer, setSearchTimer] = useState(null)


  const [locationFilterVal, setLocationFilterVal] = useState('ALL');
  const [languageFilterVal, setLanguageFilterVal] = useState("ALL")
  const [organizationSelectedZone, setOrganizationSelectedZone] = useState("")
  const [searchedAmount, setSearchedAmount] = useState("")

//  function getTransactionHistory(organizationId, zoneName, searchBy, pageNo, limit, type) {

  useEffect(() => {
    getTransactionHistory(sessionUserData?.user?.role === APP_CONSTANTS.USER_ROLE_SUPER_ADMIN ? organizationId : sessionUserData?.user?.organization?.id, organizationSelectedZone.replace(/\s/g, '').toLowerCase(), searchedAmount, currentPage, 10, "LOAD")
    return () => {
      setDeviceTransactionsList([])
      currentPage = 1;
      isHasTransactionDataHasNextPage = true
    }
  }, [organizationId]);


  const handleScroll = () => {
    const card = cardRef.current;
    if (card) {
      const scrollPercentage = (card.scrollTop / (card.scrollHeight - card.clientHeight)) * 100;
      if (scrollPercentage > 90 && isHasTransactionDataHasNextPage && !transactionDataLoading) {
        currentPage = currentPage + 1
        getTransactionHistory(sessionUserData?.user?.role === APP_CONSTANTS.USER_ROLE_SUPER_ADMIN ? "" : sessionUserData?.user?.organization?.id, organizationSelectedZone, searchedAmount, currentPage, 10, "LOAD")
      }
    }
  };


  const handleOrganizatioZoneValChange = (event) => {
    setOrganizationSelectedZone(event.target.value)
    currentPage = 1;
    getTransactionHistory(sessionUserData?.user?.role === APP_CONSTANTS.USER_ROLE_SUPER_ADMIN ? "" : sessionUserData?.user?.organization?.id, event.target.value, searchedAmount, currentPage, 10, "SEARCH")

  }
  
  const handleSerachedAmountValChange = (event) => {
    setSearchedAmount(event?.target?.value)
    currentPage = 1;
    clearTimeout(searchTimer)
    const newTimer = setTimeout(() => {
      getTransactionHistory(sessionUserData?.user?.role === APP_CONSTANTS.USER_ROLE_SUPER_ADMIN ? "" : sessionUserData?.user?.organization?.id, organizationSelectedZone, event?.target?.value, currentPage, 10, "SEARCH")

    }, 1000)
    setSearchTimer(newTimer)

  }

 


  function getTransactionHistory(organizationId, zoneName, searchBy, pageNo, limit, type) {


    const where = {
      ...(organizationId && { organizationId }),
      ...(zoneName && { branch: { zone: zoneName } }),
      ...(searchBy && { amount:searchBy }),
      
  };


    setTransactionDataLoading(true)
    GetTransactionHistory(pageNo, limit,where,"","").then((res) => {
      setTransactionDataLoading(false)
      isHasTransactionDataHasNextPage = res?.data?.hasNextPage;
      if (type === 'LOAD')
          setDeviceTransactionsList(prevList => [...prevList, ...(res?.data?.data ?? [])]);
      else if (type === 'SEARCH'){
        setDeviceTransactionsList([]);
        setDeviceTransactionsList( res?.data?.data ?? []);
      }
    }).catch((_err) => {
      setTransactionDataLoading(false)

    })
  }

  function onAddDeviceModalAction(_d) {
  }







  return (
    <Box>

      <Box sx={{ width: '100%', }}>
        <Card sx={{
          width: "100%", background: "#FFFFFF",
          boxShadow: "10px 10px 19px 1px #EAEAFF",
          borderRadius: "20px",
          marginBottom: 10
        }}
        data-testid='soundbox-transactions'>


          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 2 }} mt={1} mb={2}>

            <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start" >
              <Typography sx={{ fontSize: 16, fontWeight: 'bold' }}>
                Filter By
              </Typography>

              {
                organizationAudioCubeTerritories !== undefined && organizationAudioCubeTerritories !== null ?
                  <FormControl size="small" data-testid='filter-by-zones' sx={{ minWidth: { xs: 80, md: 150 } }}>
                    <InputLabel id="device-select-label"  >Zone </InputLabel>
                    <Select
                      labelId="device-select-label"
                      id="device-select"
                      value={organizationSelectedZone}
                      onChange={handleOrganizatioZoneValChange}
                      label="Zone"
                      >
                      <MenuItem value={""}>ALL</MenuItem>
                      {
                        organizationAudioCubeTerritories?.filter(obj => obj?.parent_id === "0")?.map((row) => (
                          <MenuItem key={row?.name} value={row?.name} sx={{ p: 1.5 }}>{row?.name}</MenuItem>
                        ))
                      }

                    </Select>
                  </FormControl>
                  :
                  null
              }


              <FormControl size="small"  sx={{ minWidth: { xs: 80, md: 150 } }}>

                <InputLabel htmlFor="outlined-adornment-password">Search Amount</InputLabel>
                <OutlinedInput
                  id="searchedAmount"
                  data-testid='search-amount-filter'
                  type='number'
                  onChange={handleSerachedAmountValChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Search Icon"
                        edge="end"
                        disabled
                      >
                        <SearchOutlinedIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Search Amount"
                />
              </FormControl>
            </Stack>
          </Stack>

          <Divider sx={{ m: 1 }} />

          {
            deviceTransactionsList !== null && deviceTransactionsList !== undefined ?



              <TableContainer sx={{ maxHeight: 400, overflowY: 'scroll' }} ref={cardRef} onScroll={handleScroll}>
                <Table aria-label="transaction_table" stickyHeader>
                  <TableHead >
                    <TableRow >
                      <TableCell sx={{ minWidth: '8vw', fontWeight: 800 }} align="center">Merchant Id</TableCell>
                      <TableCell sx={{ minWidth: '12vw', fontWeight: 800 }} align="center">Transaction Id</TableCell>
                      <TableCell sx={{ minWidth: '12vw', fontWeight: 800 }} align="center">Zone</TableCell>
                      <TableCell sx={{ minWidth: '8vw', fontWeight: 800 }} align="center">Amount</TableCell>
                      <TableCell sx={{ minWidth: '12vw', fontWeight: 800 }} align="center"> Announced</TableCell>
                      <TableCell sx={{ minWidth: '8vw', fontWeight: 800 }} align="center">Date & Time</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {deviceTransactionsList?.map((row) => (
                      <TableRow
                        key={row?.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell align="center"> {crossMarkString(row?.merchant_identifier)}</TableCell>
                        <TableCell align="center"> {crossMarkString(row?.id)}</TableCell>
                        <TableCell align="center"> {showFieldValueWithCheck(row?.branch?.zone)}</TableCell>
                        <TableCell align="center">  Rs. {showFieldValueWithCheck(row?.amount)}</TableCell>
                        <TableCell align="center"> {getTransactionAnnouncedOrNot(row?.status)}</TableCell>
                        <TableCell align="center"> {isoDateFormatInDmyhs(row?.payment_date)} </TableCell>


                      </TableRow>
                    ))}



                  </TableBody>
                </Table>
              </TableContainer>

              :
              null
          }


          {transactionDataLoading ? <LinearProgress color="success" /> : null}


        </Card>
      </Box>

     

    </Box>
  );
}
